import { j as o } from "./index.es33.js";
import { SubstringedPlaceholder as l } from "./index.es690.js";
import { HoveredToPlaceholder as x, HoveredFromPlaceholder as c } from "./index.es691.js";
import { InitialPlaceholder as d } from "./index.es692.js";

var h = function h(_ref) {
  var m = _ref.selectedDates,
      e = _ref.hoveredDate,
      i = _ref.isFocused,
      s = _ref.isOpen,
      r = _ref.inputValue,
      t = _ref.placeholder,
      f = _ref.isDisabled;

  if (e) {
    if (m[0]) return o.jsx(x, {
      hoveredDate: e,
      inputValue: r
    });
    if (!r) return o.jsx(c, {
      hoveredDate: e
    });
  }

  return r ? o.jsx(l, {
    inputValue: r
  }) : o.jsx(d, {
    isFocused: i,
    isOpen: s,
    placeholder: t,
    isDisabled: f
  });
};

export { h as RangePlaceholder };